"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PANE_OPTION = exports.PaneOption = exports.paneOptionDisabledMixin = exports.paneOptionFocusMixin = exports.paneOptionActiveMixin = exports.paneOptionHoverMixin = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_get_1 = require("@styled-system/theme-get");
var Clickable_1 = require("../Clickable");
var Cell_1 = require("../Cell");
var mixins_1 = require("../mixins");
exports.paneOptionHoverMixin = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n\n  &::before {\n    display: block;\n    content: \"\";\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    bottom: 2px;\n    left: 2px;\n    background-color: ", ";\n    border-radius: 4px;\n    z-index: -1;\n  }\n"], ["\n  position: relative;\n  z-index: 1;\n\n  &::before {\n    display: block;\n    content: \"\";\n    position: absolute;\n    top: 2px;\n    right: 2px;\n    bottom: 2px;\n    left: 2px;\n    background-color: ", ";\n    border-radius: 4px;\n    z-index: -1;\n  }\n"])), (0, theme_get_1.themeGet)("colors.hint"));
exports.paneOptionActiveMixin = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), exports.paneOptionHoverMixin);
exports.paneOptionFocusMixin = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  outline: 0;\n  background-color: ", ";\n  ", "\n"], ["\n  outline: 0;\n  background-color: ", ";\n  ", "\n"])), (0, theme_get_1.themeGet)("colors.hint"), Cell_1.cellFocusMixin);
exports.paneOptionDisabledMixin = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  pointer-events: none;\n  color: ", ";\n"], ["\n  pointer-events: none;\n  color: ", ";\n"])), (0, theme_get_1.themeGet)("colors.secondary"));
exports.PaneOption = (0, styled_components_1.default)(Clickable_1.Clickable)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none;\n  transition: box-shadow 250ms ease;\n  ", "\n\n  ", "\n\n  ", "\n  &:hover {\n    ", "\n  }\n\n  ", "\n  &:focus {\n    ", "\n  }\n\n  ", "\n  &:disabled {\n    ", "\n  }\n"], ["\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none;\n  transition: box-shadow 250ms ease;\n  ", "\n\n  ", "\n\n  ", "\n  &:hover {\n    ", "\n  }\n\n  ", "\n  &:focus {\n    ", "\n  }\n\n  ", "\n  &:disabled {\n    ", "\n  }\n"])), mixins_1.overflowEllipsisMixin, function (_a) {
    var active = _a.active;
    return active && exports.paneOptionActiveMixin;
}, function (_a) {
    var hover = _a.hover;
    return hover && exports.paneOptionHoverMixin;
}, exports.paneOptionHoverMixin, function (_a) {
    var focus = _a.focus;
    return focus && exports.paneOptionFocusMixin;
}, exports.paneOptionFocusMixin, function (_a) {
    var disabled = _a.disabled;
    return disabled && exports.paneOptionDisabledMixin;
}, exports.paneOptionDisabledMixin);
exports.PANE_OPTION = {
    borderRadius: 4,
    color: "primary",
    fontSize: [2, 2, 1, 1],
    lineHeight: 0,
    px: 4,
    py: 3,
};
exports.PaneOption.defaultProps = exports.PANE_OPTION;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=PaneOption.js.map